const WorkerJobApplicationsShift = () => {
  const demoApplications = [
    {
      id: 1,
      userName: "John Doe",
      jobTitle: "Night Security Shift",
      status: "In Progress",
    },
    {
      id: 2,
      userName: "Sarah Smith",
      jobTitle: "Warehouse Packing Shift",
      status: "In Progress",
    },
    {
      id: 3,
      userName: "Michael Brown",
      jobTitle: "Hospital Support Shift",
      status: "In Progress",
    },
    {
      id: 4,
      userName: "Emily Johnson",
      jobTitle: "School Cleaning Shift",
      status: "In Progress",
    },
  ];

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-3 border-bottom">
          My Shift Job Applications
        </h4>

        <div className="row g-3">
          {demoApplications.map((app) => (
            <div key={app.id} className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h6 className="text-primary mb-1 fw-semibold">
                    {app.userName}
                  </h6>

                  <p className="mb-2 text-muted">
                    {app.jobTitle}
                  </p>

                  <span className="badge bg-warning text-dark">
                    {app.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default WorkerJobApplicationsShift;
